<template>
  <mdb-container>
    <mdb-col v-if="showSpinner">
      <Spinner />
    </mdb-col>
    <mdb-row>
      <LocationForm @location-created="onLocationCreated" />
    </mdb-row>

    <mdb-row>
      <LocationList :locations="locations" />
    </mdb-row>
  </mdb-container>
</template>

<script>
import api from "@/api";
import Spinner from "@/components/Spinner";
import LocationForm from "@/components/LocationForm";
import LocationList from "@/components/LocationList";
import { mdbRow, mdbCol, mdbContainer } from "mdbvue";

export default {
  name: "LocationsConfig",
  components: {
    mdbRow,
    mdbCol,
    mdbContainer,
    Spinner,
    LocationForm,
    LocationList,
  },
  data() {
    return {
      locations: [],
      isLoading: true,
    };
  },

  computed: {
    showSpinner() {
      return this.isLoading;
    },
  },
  created() {
    this.isLoading = false;
    this.getLocationList();
    this.isLoading = false;
  },
  methods: {
    onLocationCreated() {
      this.getLocationList();
    },

    getLocationList() {
      api
        .getAllLocations()
        .then((response) => {
          this.locations.splice(0, response.data.length, ...response.data);
          this.isLoading = false;
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
};
</script>

<style scoped lang="scss"></style>
